import { gsap } from 'gsap/dist/gsap';

export default () => ({
    gsap,
});
